import type { ReactNode } from 'react';
import { MoreVertical } from 'lucide-react';
import { Button } from '@/components/atoms/button';
import { DropdownMenuContent } from '@/components/atoms/dropdown-menu';

// Must forward all props so Radix asChild/Slot can inject onPointerDown and other handlers.
export function RowOverflowMenuTrigger({
  disabled,
  ...props
}: React.ComponentPropsWithoutRef<typeof Button>) {
  return (
    <Button variant="ghost" size="icon-sm" className="size-7" disabled={disabled} {...props}>
      <MoreVertical className="size-3.5" />
    </Button>
  );
}

interface OverflowMenuContentProps {
  children: ReactNode;
}

export function OverflowMenuContent({ children }: OverflowMenuContentProps) {
  return (
    <DropdownMenuContent
      align="end"
      className="w-48"
      onClick={(e) => e.stopPropagation()}
      onMouseDown={(e) => e.stopPropagation()}
      onPointerDown={(e) => e.stopPropagation()}
    >
      {children}
    </DropdownMenuContent>
  );
}
